import React, { useEffect, useRef, useState } from "react";
import { FaUser, FaBuilding, FaHashtag } from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa";
import { FaEye, FaPlus } from "react-icons/fa";
import { Tab } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import DetailsTab from "./Tabs/DetailsTab";
import FinancialTab from "./Tabs/FinancialTab";
import DocumentTab from "./Tabs/DocumentTab";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import DetailsTabSaudi from "./Tabs/DetailsTabSaudi";

const CustomerCreation = () => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";

  const [customerName, setCustomerName] = useState("");
  const [deptCode, setDeptCode] = useState("");
  const [deptDesc, setDeptDesc] = useState("");
  const [accountListCustomer, setAccountListCustomer] = useState([]);
  const [deptCodeList, setDeptCodeList] = useState([]);
  const [accountListCustomerNewNum, setAccountListCustomerNewNum] =
    useState("");
  const [tabIndex, setTabIndex] = useState(0);
  const [customerType, setCustomerType] = useState("Customer");
  const [sendAccountNo, setSendAccountNo] = useState("");
  const [sendAccountNoEdit, setSendAccountNoEdit] = useState("");
  const [sendAccountNameEdit, setSendAccountNameEdit] = useState("");
  const [selectedPrefix, setSelectedPrefix] = useState("");
  const location = useLocation();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [saudiPhase, setSaudiPhase] = useState(false);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);

  const [detailsData, setDetailsData] = useState({
    primaryTel: "", //
    alternatePhone: "",
    email: "", //
    streetAddress: "", //
    address2: "", //
    whatsappLocation: "", //
    area: "", //
    buildingName: "",
    buildingNumber: "",
    plotId: "",
    subcity: "",
    postalZone: "",
    buildingType: "Office", //
    country: "UAE", //
    city: "", //
    whatsapp: false, //
    transactions: false, //
    useTrnForAll: false, //
    deliveryCollection: false, //
    note: "", //
    salesman: "", //

    // crmethod???
  });

  const [financialData, setFinancialData] = useState({
    terms: "", //
    currency: "", //
    creditMethod: "", //
    creditLimit: "", //
    dueDays: "", //
    discPercent: "", //
    pdc: "", //
    vatType: "VATApplied", //
    trn: "", //
    crn: "", //
    marginPercent: "", //
    priceSlab: "",
    availableLimit: "",
    openBalance: "", //
    openBalanceFC: "", //
    openBalanceFCCode: "",
  });
  const financialObject = {
    customerName: sendAccountNoEdit ? sendAccountNameEdit : customerName,
    accountNo: sendAccountNoEdit ? sendAccountNoEdit : sendAccountNo,
    dept: deptCode,
    deptDesc: deptDesc,
  };

  useEffect(() => {
    fetchAccountListCustomer();
    fetchDeptCodeList();
    const currentUserFromLocal = JSON.parse(
      localStorage.getItem("currentUser") || [],
    );
    const vatmodeFromLocal = currentUserFromLocal[0].VATMODE;
    console.log("vatmodeFromLocal:", vatmodeFromLocal);

    // if (vatmodeFromLocal === "UAE") {
    if (
      vatmodeFromLocal === "SAUDIPHASE1" ||
      vatmodeFromLocal === "SAUDIPHASE2"
    ) {
      setSaudiPhase(true);
    }
  }, []);

  useEffect(() => {
    console.log("saudiPhase status:", saudiPhase);
  }, [saudiPhase]);

  useEffect(() => {
    if (saudiPhase) {
      const isCrnInvalid = (financialData?.crn?.length || 0) < 10;
      const isAreaMissing = !detailsData?.area;
      const isCityMissing = !detailsData?.city;
      const isStreetMissing = !detailsData?.streetAddress;
      const isBuildingName = !detailsData?.buildingName;
      const isBuildingNumber = !detailsData?.buildingNumber;
      const isPlotId = !detailsData?.plotId;
      const isSubcity = !detailsData?.subcity;
      const isPostalZone = !detailsData?.postalZone;

      setIsSaveDisabled(
        isCrnInvalid ||
          isAreaMissing ||
          isCityMissing ||
          isStreetMissing ||
          isBuildingName ||
          isBuildingNumber ||
          isPlotId ||
          isSubcity ||
          isPostalZone,
      );
    }
  }, [financialData, detailsData]);

  useEffect(() => {
    //only in new mode
    if (sendAccountNoEdit) {
      return;
    }
    fetchAccountListCustomer();
  }, [customerType]);

  useEffect(() => {
    const state = location.state;
    if (state?.tabIndex !== undefined) {
      setTabIndex(state.tabIndex);
    }
    if (state?.editAccNo) {
      const full = state.editAccNo; // e.g. "12051996"
      const custNameEdit = state.custName; // e.g. "12051996"
      console.log("🚀 ~ CustomerCreation ~ full:", full);
      setSendAccountNoEdit(full);
      setSendAccountNameEdit(custNameEdit);
      const prefix = full.slice(0, 4); // "1205"
      const suffix = full.slice(4, 8); // "1996"

      setSendAccountNo(full); // <-- important for DocumentTab
      setAccountListCustomerNewNum(suffix);
      setSelectedPrefix(prefix); // pre-select <select>
    }
  }, [location.state]);

  const docTabRef = useRef();

  const handleCustomerTypeChange = (event) => {
    setCustomerType(event.target.value);
    console.log("Selected:", event.target.value);
  };

  const fetchAccountListCustomer = async () => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    // let apiURL = `${apiPaths[0]?.API_CONFIG}/api/CRMAccountList/${companyCode}/TYPELIST/${department}/CUSTOMERS/-/-`;
    let apiURL = `${
      apiPaths[0]?.API_CONFIG
    }/api/CRMAccountList/${COMPANY_CODE}/TYPELIST/${department}/${
      customerType === "Supplier" ? "SUPPLIERS" : "CUSTOMERS"
    }/-/-`;

    try {
      const response = await axios.get(apiURL);
      // console.log("🚀 ~ fetchAccountListCustomer ~ response:", response.data)
      const data = response.data;
      setAccountListCustomer(data || []);
      // const initialAccountList = data[0]?.glcat;
      // console.log(
      //   "🚀 ~ CustomerCreation ~ initialAccountList:",
      //   initialAccountList
      // );
      // if (accountListCustomerNewNum === "") {
      //   handleAccountListSelect(initialAccountList);
      // }

      if (location.state?.editAccNo) {
        const prefix = location.state.editAccNo.slice(0, 4);
        const match = data.find((a) => a.glcat === prefix);
        if (match) {
          setSelectedPrefix(match.glcat);
          handleAccountListSelect(match.glcat); // also fetches the suffix
          return;
        }
      }

      // ---- Normal flow (first item) ----
      // const first = data[0]?.glcat;
      // if (first && !selectedPrefix) {
      //   setSelectedPrefix(first);
      //   handleAccountListSelect(first);
      // }

      if (!location.state?.editAccNo) {
        const first = data[0]?.glcat;
        if (first && !selectedPrefix) {
          setSelectedPrefix(first);
          handleAccountListSelect(first);
        }
      }

      console.log("EDIT MODE?", !!location.state?.editAccNo);
      console.log("SELECTED PREFIX:", selectedPrefix);
      console.log(
        "ACCOUNT LIST:",
        accountListCustomer.map((a) => a.glcat),
      );
    } catch (err) {
      console.error("Error while fetching accountlist", err);
    }
  };

  const fetchDeptCodeList = async () => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    // let apiURL = `${apiPaths[0]?.API_CONFIG}/api/CpaysCount/${companyCode}/DEPTLIST/-/-`;
    let apiURL = `${apiPaths[0]?.API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/DEPTLIST/-/-`;

    try {
      const response = await axios.get(apiURL);
      console.log("🚀 ~ fetchDeptCodeList ~ response:", response.data);
      const data = response.data;
      setDeptCodeList(data || []);
    } catch (err) {
      console.error("Error while fetching accountlist", err);
    }
  };

  const fetchAccountCutomerNewNum = async (selectedAccountNo) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    // let apiURL = `${apiPaths[0]?.API_CONFIG}/api/CRMGLSettings/${companyCode}/ACCOUNTNEWNUM/${selectedAccountNo}/-/-/-`;
    let apiURL = `${apiPaths[0]?.API_CONFIG}/api/CRMGLSettings/${COMPANY_CODE}/ACCOUNTNEWNUM/${selectedAccountNo}/-/-/-`;

    try {
      const response = await axios.get(apiURL);
      // console.log("🚀 ~ fetchAccountListCustomerNewNum ~ response:", response.data[0].Column1)
      const data = response.data[0].Column1;

      console.log("selected Account No", data);
      // selected
      setSendAccountNo(data);
      setAccountListCustomerNewNum(data.slice(4, 8));
    } catch (err) {
      console.error("Error while fetching accountlistNewNum", err);
    }
  };

  const navigate = useNavigate();
  const onCustomerView = () => {
    navigate(`/customerView`, { state: { customerType: customerType } });
  };
  const onCustomerCreation = () => {
    navigate(`/customerCreation`);
    window.location.reload(); // forces full refresh
  };

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleAccountListSelect = (selectedAccountNo) => {
    console.log(
      "🚀 ~ handleAccountListSelect ~ selectedAccountNo:",
      selectedAccountNo,
    );
    if (!sendAccountNoEdit) {
      fetchAccountCutomerNewNum(selectedAccountNo);
    }
  };

  const onCustomerSaveAll = async () => {
    if (docTabRef.current) {
      docTabRef?.current.saveDocuments();
    }

    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    // let apiURL = `${apiPaths[0]?.API_CONFIG}/api/CRMAccountReg`;
    let apiURL = `${apiPaths[0]?.API_CONFIG}/api/CRMCustSupptCRMReg`;

    const customerPayload = [
      {
        cmpcode: companyCode,
        mod: sendAccountNoEdit ? "M" : "I",
        account: sendAccountNo || "",
        acctype: selectedPrefix || "",
        accdesc: customerName || "",
        balance_open: Number(financialData.openBalance) || 0,
        curbalance_open: Number(financialData.openBalanceFC) || 0,
        dr: 0,
        cr: 0,
        fc: financialData.currency || "AED",
        // fc: financialData.openBalanceFCCode || "AED",
        fdr: 0,
        fcr: 0,
        divcode: "",
        keywords: "",
        adr1: detailsData.address2 || "",
        adr2: detailsData.streetAddress || "",
        adr3: detailsData.city || "",
        adr4: detailsData.buildingNumber || "", // building number
        adr5: detailsData.buildingName || "", // building name
        tel: detailsData.primaryTel || "",
        fax: detailsData.plotId || "", //plot Id
        mobile: detailsData.alternatePhone || "",
        salesman: detailsData.salesman?.EMP_ID || "",
        areacode: detailsData.area || "",
        email: detailsData.email || "",
        remarks: "",
        country: detailsData.country || "",
        state: detailsData.city || "",
        crlimit: Number(financialData.creditLimit) || 0,
        curcrlimit: 0,
        currency: financialData.currency || "AED",
        duedays: Number(financialData.dueDays) || 0,
        terms: financialData.terms || "",
        crmethod: financialData.creditMethod || "",
        cntrlcode: "CUST",
        avtive: "Y",
        colourcode: "",
        price_cat: financialData.priceSlab || "",
        grade: detailsData.postalZone || "", //Postal Zone
        vattype: financialData.vatType || "",
        vatregno: financialData.crn || "", //CRN
        shippingadr: detailsData.subcity || "", //Sub city
        create_user: "",
        discount: Number(financialData.discPercent) || 0,
        margin: Number(financialData.marginPercent) || 0,
        GPSCorditate: detailsData.whatsappLocation || "",
        PriWhatsapp: detailsData.whatsapp ? "Y" : "",
        OtWhatsapp: "",
        QtnStat: detailsData.transactions ? "Y" : "",
        InvStat: detailsData.useTrnForAll ? "Y" : "",
        RetnStat: detailsData.deliveryCollection ? "Y" : "",
        UserTrn: financialData.trn || "",
        UseForDel: "",
        custtype: "LOCAL",
        autoid: "1",
        patron: "",
        patrontype: "",
        officenumber: detailsData.buildingType || "",
        regno: "",
        dumpfield: detailsData.note || "",
      },
    ];

    try {
      const response = await axios.post(apiURL, customerPayload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("🚀 ~ saved Customer:", response);
      const autoId = response.data.autoid;
      console.log("🚀 Customer saved, now saving docs with:", autoId);
      setSnackbarMsg("Customer saved successfully");
      setSnackbarType("success");
      setSnackbarOpen(true);

      if (docTabRef.current) {
        docTabRef.current.saveDocuments(autoId);
      }

      setCustomerName("");
      setDetailsData({
        primaryTel: "",
        alternatePhone: "",
        email: "",
        streetAddress: "",
        address2: "",
        whatsappLocation: "",
        area: "",
        buildingName: "",
        buildingNumber: "",
        plotId: "",
        subcity: "",
        postalZone: "",
        buildingType: "Office",
        country: "UAE",
        city: "",
        whatsapp: false,
        transactions: false,
        useTrnForAll: false,
        deliveryCollection: false,
        note: "",
        salesman: "",
      });
      setFinancialData({
        terms: "",
        currency: "",
        creditMethod: "",
        creditLimit: "",
        dueDays: "",
        discPercent: "",
        pdc: "",
        vatType: "VATApplied",
        trn: "",
        crn: "",
        marginPercent: "",
        priceSlab: "",
        availableLimit: "",
        openBalance: "",
        openBalanceFC: "",
        openBalanceFCCode: "",
      });

      setTimeout(() => {
        navigate("/businessPartners");
      }, 1000);
    } catch (err) {
      console.error("Error while saving Customer", err);
      setSnackbarMsg(err?.response?.data?.message || "Failed to save customer");
      setSnackbarType("error");
      setSnackbarOpen(true);
    }
  };

  const onCustomerSave = async () => {
    if (!sendAccountNoEdit && docTabRef.current) {
      docTabRef?.current?.saveDocDetails();
    }

    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    // let apiURL = `${apiPaths[0]?.API_CONFIG}/api/CRMAccountReg`;
    let apiURL = `${apiPaths[0]?.API_CONFIG}/api/CRMCustSupptCRMReg`;

    ////////////////////////////////////
    //     account: sendAccountNo || "",
    const customerPayload = [
      {
        cmpcode: companyCode,
        mod: sendAccountNoEdit ? "M" : "I",
        account: sendAccountNoEdit ? sendAccountNoEdit : sendAccountNo || "",
        acctype: selectedPrefix || "",
        accdesc: sendAccountNoEdit ? sendAccountNameEdit : customerName || "",
        balance_open: Number(financialData.openBalance) || 0,
        curbalance_open: Number(financialData.openBalanceFC) || 0,
        dr: 0,
        cr: 0,
        fc: financialData.currency || "AED",
        // fc: financialData.openBalanceFCCode || "AED",
        fdr: 0,
        fcr: 0,
        divcode: "",
        keywords: "",
        adr1: detailsData.address2 || "",
        adr2: detailsData.streetAddress || "",
        adr3: detailsData.city || "",
        adr4: detailsData.buildingNumber || "", // building number earlier passing empty
        adr5: detailsData.buildingName || "", // building name earlier passing empty
        tel: detailsData.primaryTel || "",
        fax: detailsData.plotId || "", //plot Id earlier passing empty
        mobile: detailsData.alternatePhone || "",
        salesman: detailsData.salesman?.EMP_ID || "",
        areacode: detailsData.area || "",
        email: detailsData.email || "",
        remarks: "",
        country: detailsData.country || "",
        state: detailsData.city || "",
        crlimit: Number(financialData.creditLimit) || 0,
        curcrlimit: 0,
        currency: financialData.currency || "AED",
        duedays: Number(financialData.dueDays) || 0,
        terms: financialData.terms || "",
        crmethod: financialData.creditMethod || "",
        cntrlcode: "CUST",
        avtive: "Y",
        colourcode: "",
        price_cat: financialData.priceSlab || "",
        grade: detailsData.postalZone || "", //Postal Zone  earlier passing empty
        vattype: financialData.vatType || "",
        vatregno: financialData.crn || "", //CRN eralier passing empty
        shippingadr: detailsData.subcity || "", //Sub city check this also what faizan passed erlier
        create_user: "",
        discount: Number(financialData.discPercent) || 0,
        margin: Number(financialData.marginPercent) || 0,
        GPSCorditate: detailsData.whatsappLocation || "",
        PriWhatsapp: detailsData.whatsapp ? "Y" : "",
        OtWhatsapp: "",
        QtnStat: detailsData.transactions ? "Y" : "",
        InvStat: detailsData.useTrnForAll ? "Y" : "",
        RetnStat: detailsData.deliveryCollection ? "Y" : "",
        UserTrn: financialData.trn || "",
        UseForDel: "",
        custtype: "LOCAL",
        autoid: "1",
        patron: "",
        patrontype: "",
        officenumber: detailsData.buildingType || "",
        regno: "",
        dumpfield: detailsData.note || "",
      },
    ];

    console.log("customerPayload", customerPayload);

    try {
      const response = await axios.post(apiURL, customerPayload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("🚀 ~ saved Customer:", response);
      const data = response.data;
      // setDeptCodeList(data || []);
      setSnackbarMsg("Customer editted successfully");
      setSnackbarType("success");
      setSnackbarOpen(true);
      setTimeout(() => {
        navigate("/businessPartners");
      }, 1000);
    } catch (err) {
      console.error("Error while saving Customer", err);
      setSnackbarMsg(err?.response?.data?.message || "Failed to edit customer");
      setSnackbarType("error");
      setSnackbarOpen(true);
    }
  };

  const onBack = () => navigate("/businessPartners");

  return (
    <div className="p-6 ">
      {/* Header Section */}
      <div className="flex flex-wrap items-center justify-between mb-4">
        <div className="flex gap-12 justify-between items-center">
          <h2 className="text-xl text-gray-800 ">
            {sendAccountNoEdit ? "Customer Edit" : "Customer Creation"}
          </h2>

          {/* <RadioGroup
            row
            name="customerType"
            value={customerType}
            onChange={handleCustomerTypeChange}
            className="flex items-center"
          >
            <FormControlLabel
              value="Customer"
              control={<Radio size="small" color="primary" />}
              label="Customer"
            />
            <FormControlLabel
              value="Supplier"
              control={<Radio size="small" color="primary" />}
              label="Supplier"
            />
          </RadioGroup> */}
        </div>
        {sendAccountNoEdit ? (
          <div className="flex justify-center items-center gap-4">
            <button
              onClick={onCustomerCreation}
              className="relative ml-4 bg-green-600 text-white font-medium text-[17px] px-2 py-[0.35em]  h-[1.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer   group"
            >
              <span className="mr-8">New</span>
              <div className="absolute right-[0.3em] bg-white h-[1.2em] w-[1.4em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)]  active:scale-95">
                <FaPlus className=" text-green-600 " />
              </div>
            </button>
            <button
              onClick={onBack}
              className=" relative bg-gray-600 text-white font-medium text-[17px] px-2 py-[0.25em] pl-3 h-[1.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer group"
            >
              <span className="mr-8">Back</span>
              <div className="absolute right-[0.3em] bg-white h-[1.4em] w-[1.4em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)] active:scale-95">
                <FaArrowLeft className="text-gray-600" />
              </div>
            </button>
          </div>
        ) : (
          <>
            {/* <button
              onClick={onCustomerView}
              className="relative ml-4 bg-blue-600 text-white font-medium text-[17px] px-2 py-[0.35em]  h-[1.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer   group"
            >
              <span className="mr-8">View</span>
              <div className="absolute right-[0.3em] bg-white h-[1.2em] w-[1.4em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)]  active:scale-95">
                <FaEye className=" text-blue-600 " />
              </div>
            </button> */}
            <button
              onClick={onBack}
              className=" relative bg-gray-600 text-white font-medium text-[17px] px-2 py-[0.25em] pl-3 h-[1.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer group"
            >
              <span className="mr-10">Back</span>
              <div className="absolute right-[0.3em] bg-white h-[1.4em] w-[1.4em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)] active:scale-95">
                <FaArrowLeft className="text-gray-600" />
              </div>
            </button>
          </>
        )}
      </div>

      <div className="mb-4 bg-white flex justify-between items-center p-4 rounded-lg shadow-sm">
        <div className="w-[30%]">
          <label className="block text-sm font-medium mb-1 flex items-center">
            <FaUser className="mr-2 text-gray-600" />
            {customerType === "Supplier" ? "Supplier Name" : "Customer Name"}
          </label>

          {sendAccountNoEdit ? (
            <>
              <input
                // readOnly
                value={sendAccountNameEdit}
                onChange={(e) => setSendAccountNameEdit(e.target.value)}
                className="w-[64%] px-1 py-2 text-sm rounded bg-gray-100 border border-gray-200"
              />
            </>
          ) : (
            <input
              placeholder={
                customerType === "Supplier"
                  ? "Enter Supplier Name Here..."
                  : "Enter Customer Name Here..."
              }
              // type="date"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
              className="placeholder-gray-400 w-full px-3 py-2 text-sm   rounded bg-gray-100 border border-gray-200  "
            />
          )}
        </div>

        <div className="flex gap-4 items-center justify-center w-[60%]">
          <div className="w-[30%]">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaHashtag className="mr-2 text-gray-600" />
              Account
            </label>
            {/* <select
                onChange={(e) => handleAccountListSelect(e.target.value)}
                placeholder="placeholder-gray-400 Enter Code Here..."
                className="w-[34%] px-1 py-2 text-sm   rounded bg-gray-100 border border-gray-200  "
                >
                {accountListCustomer.map((acc, index) => (
                  <option key={index} value={acc.glcat}>
                  {acc.glcat}
                  </option>
                  ))}
                  </select> */}
            {sendAccountNoEdit ? (
              <input
                readOnly
                value={sendAccountNoEdit}
                className="w-[100px] px-3 py-2 text-sm rounded bg-gray-100 border border-gray-200"
              />
            ) : (
              <div className="flex ">
                <select
                  value={selectedPrefix}
                  onChange={(e) => {
                    setSelectedPrefix(e.target.value);
                    handleAccountListSelect(e.target.value);
                  }}
                  className="w-[80px] px-1 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                >
                  {accountListCustomer.map((acc) => (
                    <option key={acc.glcat} value={acc.glcat}>
                      {acc.glcat}
                    </option>
                  ))}
                </select>

                <input
                  readOnly
                  value={accountListCustomerNewNum}
                  className="w-[80px] px-1 py-2 text-sm rounded bg-gray-100 border border-gray-200"
                />
              </div>
            )}
          </div>
          <div className="w-full ">
            <label className="block text-sm font-medium mb-1 flex items-center">
              <FaBuilding className="mr-2 text-gray-600" /> Dept Code
            </label>

            <select
              // onChange={(e) => {
              //   setDeptCode(e.target.value)
              //   setDeptDesc(dept.deptnodesc)
              // }}
              onChange={(e) => {
                const selectedDept = deptCodeList.find(
                  (dept) => dept.deptno === e.target.value,
                );
                setDeptCode(e.target.value);
                setDeptDesc(selectedDept ? selectedDept.deptnodesc : "");
              }}
              placeholder="placeholder-gray-400 Enter Code Here..."
              className=" px-1 py-2 text-sm   rounded bg-gray-100 border border-gray-200  "
            >
              <option className="italic text-gray-300" value={"all"}>
                ALL
              </option>
              {deptCodeList.map((dept, index) => (
                <option key={index} value={dept.deptno}>
                  {dept.deptnodesc}
                </option>
              ))}
            </select>
            {/* </div> */}
          </div>
        </div>
      </div>

      {/*<div className="bg-white shadow-sm rounded-lg p-2">
        <div className="rounded-md">
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            className=""
            TabIndicatorProps={{
              className: "hidden", // Hide default MUI indicator
            }}
          >
           <CustomTab label="Details" icon={<FaInfoCircle className="" />} />
            <CustomTab
              label="Financial Information"
              icon={<FaMoneyCheckAlt className="" />}
            /> 
            <CustomTab
              label="Details & Financial Information"
              icon={<FaInfoCircle className="" />}
            />
            <CustomTab
              label="Document Details"
              icon={<FaFileAlt className="" />}
            />
          </Tabs> 
        </div>
      </div> */}

      <div className="mt-4">
        {/* {tabIndex === 0 && ( */}
        {/* <DetailsTab onDetailsChange={setDetailsData} /> */}
        <div className="space-y-6">
          {saudiPhase ? (
            <DetailsTabSaudi
              onDetailsChange={setDetailsData}
              accountNoEdit={sendAccountNoEdit}
              selectedAccountNo={sendAccountNo}
            />
          ) : (
            <DetailsTab
              onDetailsChange={setDetailsData}
              accountNoEdit={sendAccountNoEdit}
              selectedAccountNo={sendAccountNo}
            />
          )}
          <FinancialTab
            onFinancialChange={setFinancialData}
            data={financialObject}
            accountNoEdit={sendAccountNoEdit}
          />
        </div>
        {/* )} */}
        {/* {tabIndex === 1 && (
          <DocumentTab accountNo={sendAccountNo} ref={docTabRef} />
        )} */}
      </div>

      {sendAccountNoEdit && (
        <div className="flex justify-center items-center mt-8">
          <button
            onClick={onCustomerSave}
            // disabled={isDisabled}
            className={`px-3 py-2 text-white text-sm border rounded w-[270px] transition bg-gray-700 hover:bg-black`}
          >
            Save Personal & Financial
          </button>
        </div>
      )}

      <div className="mt-4 bg-white shadow-md rounded-lg p-2">
        <Accordion
          sx={{
            boxShadow: "none",
            "--Paper-shadow": "none",
            "&:before": { display: "none" },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <h2 className="text-lg font-semibold text-gray-700 ">
              Document Details
            </h2>
          </AccordionSummary>
          <AccordionDetails>
            <DocumentTab
              accountNo={sendAccountNo}
              ref={docTabRef}
              accountNoEdit={sendAccountNoEdit}
            />
          </AccordionDetails>
        </Accordion>
      </div>

      {/* {tabIndex !== 1 && ( */}
      {!sendAccountNoEdit && (
        <div className="flex justify-center items-center mt-8">
          <button
            onClick={onCustomerSaveAll}
            disabled={isSaveDisabled}
            className={`px-3 py-2 text-sm border rounded w-[270px] transition
    ${
      isSaveDisabled
        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
        : "bg-gray-700 text-white hover:bg-black"
    }`}
          >
            Save All
          </button>
        </div>
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={snackbarType}
          onClose={() => setSnackbarOpen(false)}
        >
          {snackbarMsg}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default CustomerCreation;
